(() => {
  const configElement = document.getElementById('HohoBundleConfig');
  if (!configElement) return;
  const config = JSON.parse(configElement.textContent);
  const ids = new Set(config.ids.filter(Boolean).map(String));
  const eligibility = new Map((config.cart?.items || []).map(item => [String(item.product_id), ids.has(String(item.product_id))]));
  ids.forEach(id => eligibility.set(id, true));
  const pendingEligibility = new Map();
  const totals = [0,1600,3000,4000,5600,7000,8000,9600,11000,12000,13600,15000,16000];
  let latestCart = config.cart;
  let requestVersion = 0;
  const silhouettes = [...(config.roster || [])].sort(() => Math.random() - .5).slice(0,3);
  const compactMoney = cents => money(cents).replace(/^CA\$/, '$').replace(/\.00$/, '');
  function slot(item, index, browseUrl) {
    const node = document.createElement('a');
    node.className = 'hoho-trio__slot' + (item ? ' is-filled' : ' is-empty');
    node.href = item ? (item.url || '/products/' + encodeURIComponent(item.handle || '')) : browseUrl;
    if (item) {
      const image = document.createElement('img');
      image.src = item.featured_image?.url || item.image || '';
      image.alt = item.product_title || item.title || '';
      image.loading = 'lazy';
      image.width = 96; image.height = 96;
      if (image.getAttribute('src')) node.append(image);
      else node.textContent = image.alt;
    } else {
      node.setAttribute('aria-label', text('empty_slot'));
      const silhouette = silhouettes[index % silhouettes.length];
      if (silhouette) {
        const shape = document.createElement('span');
        shape.className = 'hoho-trio__silhouette';
        shape.setAttribute('aria-hidden','true');
        shape.style.setProperty('--sx', (silhouette.col * 20) + '%');
        shape.style.setProperty('--sy', (silhouette.row * 20) + '%');
        shape.style.setProperty('--clip-top', silhouette.top + '%');
        shape.style.setProperty('--offset-x', (silhouette.offsetX || 0) + '%');
        shape.style.setProperty('--offset-y', (silhouette.offsetY || 0) + '%');
        node.append(shape);
      }
      const question = document.createElement('span');
      question.className = 'hoho-trio__question'; question.textContent = '?'; question.setAttribute('aria-hidden','true');
      const plus = document.createElement('span');
      plus.className = 'hoho-trio__plus'; plus.textContent = '+'; plus.setAttribute('aria-hidden','true');
      node.append(question,plus);
    }
    return node;
  }
  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {style:'currency',currency:latestCart?.currency || 'CAD',maximumFractionDigits:2}).format(cents/100);
  const text = (key, values = {}) => Object.entries(values).reduce((value,[name,replacement]) => value.split('__'+name+'__').join(String(replacement)),config.strings[key] || '');
  function bundleDiscount(cart) {
    return (cart.items || []).reduce((total,item) => total + (item.line_level_discount_allocations || item.discount_allocations || []).reduce((sum,allocation) => {
      const title = allocation.discount_application?.title || '';
      return /^(Any [23] charms for|Charm bundles:)/.test(title) ? sum + Number(allocation.amount || 0) : sum;
    },0),0);
  }
  function render(cart, animate = true) {
    if (!cart?.items) return;
    latestCart = cart;
    const count = cart.items.reduce((sum,item) => sum + (ids.has(String(item.product_id)) ? Number(item.quantity) : 0),0);
    const saved = bundleDiscount(cart);
    const units = [];
    for (const item of cart.items) if (ids.has(String(item.product_id))) {
      const quantity = Math.min(Number(item.quantity),12-units.length);
      for (let i=0;i<quantity;i++) units.push(item);
    }
    const cappedCount = Math.min(count,12);
    const completed = Math.floor(cappedCount/3);
    const remainder = cappedCount%3;
    const unknown = cart.items.some(item => !eligibility.has(String(item.product_id)));
    const validPricing = !unknown && (cart.currency || 'CAD') === 'CAD';
    const shipping = (cart.currency || 'CAD') === 'CAD' && Number(cart.total_price) >= 4000;
    document.querySelectorAll('[data-hoho-bundle-cart]').forEach(panel => {
      const previousSaved = Number(panel.dataset.saved || 0);
      const browse = panel.querySelector('[data-hoho-trio-browse]');
      const grid = panel.querySelector('[data-hoho-trio-slots]');
      const title = panel.querySelector('[data-hoho-trio-title]');
      const status = panel.querySelector('[data-hoho-bundle-status]');
      const summary = panel.querySelector('[data-hoho-trio-completed]');
      const savings = panel.querySelector('[data-hoho-trio-saved]');
      const shippingBadge = panel.querySelector('[data-hoho-trio-shipping]');
      if (!grid || !browse || !title || !status || !summary) return;
      const complete = cappedCount > 0 && remainder === 0;
      title.textContent = complete ? text(completed===1?'trio_complete':'trios_complete',{quantity:completed}) : text(completed?'next_trio':'build_trio');
      summary.hidden = !(completed && remainder);
      summary.textContent = text(completed===1?'completed_one':'completed_many',{quantity:completed,amount:compactMoney(saved)});
      grid.replaceChildren();
      if (complete) {
        const shown = panel.closest('#CartDrawer') && units.length>6 ? units.slice(-3) : units;
        shown.forEach((item,index)=>grid.append(slot(item,index,browse.href)));
      } else {
        const current = units.slice(completed*3);
        for(let index=0;index<3;index++) grid.append(slot(current[index],index,browse.href));
      }
      status.textContent = !validPricing ? text('mix') : count>12 ? text('over_limit') : complete ? '' : count===0 ? text('pick_trio') : text(remainder===2?'one_more':'two_more',{amount:compactMoney(remainder===2?1000:2400)});
      status.hidden = !status.textContent;
      savings.hidden = !(saved>0 && !(completed && remainder));
      savings.textContent = text('saved_short',{amount:compactMoney(saved)});
      shippingBadge.hidden = !shipping;
      browse.hidden = complete || count>=12;
      browse.textContent = text(count===0?'choose_trio':remainder===2?'pick_third':'find_friends');
      panel.dataset.saved = String(saved);
      panel.dataset.charmCount = String(count);
      panel.classList.toggle('is-saved', saved>0);
      panel.classList.toggle('is-complete', complete);
      const summaryContainer = panel.closest('.cart-summary');
      if(summaryContainer) {
        const progress = summaryContainer.querySelector('.cart-summary__shipping');
        if(progress) progress.hidden = shipping;
      }
      if (animate && saved>previousSaved) {
        panel.classList.remove('is-celebrating'); void panel.offsetWidth; panel.classList.add('is-celebrating');
      }
    });
    const drawer = document.querySelector('#CartDrawer');
    if(drawer) {
      const footer = drawer.querySelector('.cart-drawer__footer');
      if(footer) footer.hidden = cart.items.length===0;
      const progress = drawer.querySelector('.cart-drawer__shipping');
      if(progress) progress.hidden = shipping;
    }
  }

  async function checkEligibility(item) {
    const id = String(item.product_id);
    if (eligibility.has(id)) return;
    if (pendingEligibility.has(id)) return pendingEligibility.get(id);
    if (!item.handle) return;
    const pending = (async () => {
      try {
        const response = await fetch((window.Shopify?.routes?.root || '/')+'products/'+encodeURIComponent(item.handle)+'.js',{headers:{Accept:'application/json'},credentials:'same-origin'});
        if (!response.ok) return;
        const productData = await response.json();
        const tags = Array.isArray(productData.tags) ? productData.tags : String(productData.tags || '').split(',').map(tag => tag.trim());
        const eligible = tags.includes('bundle-charm');
        eligibility.set(id,eligible);
        if (eligible) ids.add(id);
      } catch {}
    })();
    pendingEligibility.set(id,pending);
    await pending;
    pendingEligibility.delete(id);
  }
  function update(cart, animate = true) {
    if (!cart?.items) return;
    latestCart = cart;
    const version = ++requestVersion;
    const unknown = cart.items.filter(item => !eligibility.has(String(item.product_id)));
    if (!unknown.length) {
      render(cart,animate);
      return;
    }
    return Promise.all(unknown.map(checkEligibility)).then(() => {
      if (version === requestVersion) render(cart,animate);
    });
  }
  async function sync() {
    const version = ++requestVersion;
    try {
      const response = await fetch((window.Shopify?.routes?.root || '/')+'cart.js',{headers:{Accept:'application/json'},credentials:'same-origin'});
      if (!response.ok) return;
      const cart = await response.json();
      if (version === requestVersion) update(cart);
    } catch {}
  }
  update(latestCart,false);
  document.addEventListener('cart:updated',(event) => {
    if (event.detail?.cart) update(event.detail.cart);
    else sync();
  });
  document.addEventListener('cart-page:replaced',() => render(latestCart,false));
  document.addEventListener('cart:drawer:opened',sync);
  document.addEventListener('visibilitychange',() => { if (!document.hidden) sync(); });
})();
